//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const OM_CLIENT_API_BASE_URL = new InjectionToken<string>('OM_CLIENT_API_BASE_URL');

export class ServiceBaseConfig {
  public key: string;
}

export class ServiceBase {
  private readonly apiKey: string;
  private readonly apimHeaderName: string = 'Ocp-Apim-Subscription-Key';
  private readonly tenantIdHeaderName: string = 'TenantId';
  private readonly tenantIdLocalStorageKey: string = 'samplicity-dtp-current-client';
  private readonly idTokenKey: string = 'samplicity-id-token';

  constructor(config: ServiceBaseConfig) {
    this.apiKey = config.key;
  }

  protected transformOptions(options: any) {
    let headers: HttpHeaders = options.headers;

    if (this.apiKey) {
      headers = headers.append(this.apimHeaderName, this.apiKey);
    }

    const tenantId = sessionStorage.getItem(this.tenantIdLocalStorageKey);
    if (tenantId) {
      headers = headers.append(this.tenantIdHeaderName, tenantId);
    }

    const token = localStorage.getItem(this.idTokenKey);
    if (token) {
      headers = headers.append('Authorization', 'Bearer ' + token);
    }

    options.headers = headers;

    return Promise.resolve(options);
  }
}

@Injectable()
export class OrderManagementClient extends ServiceBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(ServiceBaseConfig) configuration: ServiceBaseConfig, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(OM_CLIENT_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentClientSpecialtyMappings(): Observable<AjaxResponseOfListOfMappingDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetCurrentClientSpecialtyMappings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentClientSpecialtyMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentClientSpecialtyMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfListOfMappingDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfListOfMappingDetailsDto>;
        }));
    }

    protected processGetCurrentClientSpecialtyMappings(response: HttpResponseBase): Observable<AjaxResponseOfListOfMappingDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListOfMappingDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param updateDtos (optional) 
     * @return Success
     */
    saveClientSpecialtyMappings(updateDtos: MappingDetailsDto[] | null | undefined): Observable<AjaxResponseOfMappingDetailsUpdateResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/SaveClientSpecialtyMappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDtos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveClientSpecialtyMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveClientSpecialtyMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfMappingDetailsUpdateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfMappingDetailsUpdateResultDto>;
        }));
    }

    protected processSaveClientSpecialtyMappings(response: HttpResponseBase): Observable<AjaxResponseOfMappingDetailsUpdateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfMappingDetailsUpdateResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param exportTypeId (optional) 
     * @return Success
     */
    getCurrentClientExportData(exportTypeId: string | null | undefined): Observable<AjaxResponseOfExportFileDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetCurrentClientExportData?";
        if (exportTypeId !== undefined && exportTypeId !== null)
            url_ += "exportTypeId=" + encodeURIComponent("" + exportTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentClientExportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentClientExportData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfExportFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfExportFileDto>;
        }));
    }

    protected processGetCurrentClientExportData(response: HttpResponseBase): Observable<AjaxResponseOfExportFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfExportFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dto (optional) 
     * @return Success
     */
    uploadClientSpecialtyMappingFile(dto: ClientSpecialtyFileUploadDto | null | undefined): Observable<AjaxResponseOfClientSpecialtyFileUploadDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/UploadClientSpecialtyMappingFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadClientSpecialtyMappingFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadClientSpecialtyMappingFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfClientSpecialtyFileUploadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfClientSpecialtyFileUploadDto>;
        }));
    }

    protected processUploadClientSpecialtyMappingFile(response: HttpResponseBase): Observable<AjaxResponseOfClientSpecialtyFileUploadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfClientSpecialtyFileUploadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCurrentClientDesignationMappings(): Observable<AjaxResponseOfListOfMappingDetailsDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/GetCurrentClientDesignationMappings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetCurrentClientDesignationMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentClientDesignationMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfListOfMappingDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfListOfMappingDetailsDto>;
        }));
    }

    protected processGetCurrentClientDesignationMappings(response: HttpResponseBase): Observable<AjaxResponseOfListOfMappingDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfListOfMappingDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param updateDtos (optional) 
     * @return Success
     */
    saveClientDesignationMappings(updateDtos: MappingDetailsDto[] | null | undefined): Observable<AjaxResponseOfMappingDetailsUpdateResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/SaveClientDesignationMappings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDtos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSaveClientDesignationMappings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveClientDesignationMappings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfMappingDetailsUpdateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfMappingDetailsUpdateResultDto>;
        }));
    }

    protected processSaveClientDesignationMappings(response: HttpResponseBase): Observable<AjaxResponseOfMappingDetailsUpdateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfMappingDetailsUpdateResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dto (optional) 
     * @return Success
     */
    uploadClientDesignationMappingFile(dto: ClientDesignationFileUploadDto | null | undefined): Observable<AjaxResponseOfClientDesignationFileUploadDto> {
        let url_ = this.baseUrl + "/api/services/app/Client/UploadClientDesignationMappingFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUploadClientDesignationMappingFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadClientDesignationMappingFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfClientDesignationFileUploadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfClientDesignationFileUploadDto>;
        }));
    }

    protected processUploadClientDesignationMappingFile(response: HttpResponseBase): Observable<AjaxResponseOfClientDesignationFileUploadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfClientDesignationFileUploadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getFilesByTenantId(): Observable<AjaxResponseOfIEnumerableOfTenantFileDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantFile/GetFilesByTenantId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFilesByTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilesByTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AjaxResponseOfIEnumerableOfTenantFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AjaxResponseOfIEnumerableOfTenantFileDto>;
        }));
    }

    protected processGetFilesByTenantId(response: HttpResponseBase): Observable<AjaxResponseOfIEnumerableOfTenantFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AjaxResponseOfIEnumerableOfTenantFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AjaxResponseOfListOfMappingDetailsDto implements IAjaxResponseOfListOfMappingDetailsDto {
    result: MappingDetailsDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfListOfMappingDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(MappingDetailsDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfListOfMappingDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfListOfMappingDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfListOfMappingDetailsDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfListOfMappingDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfListOfMappingDetailsDto {
    result: MappingDetailsDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class MappingDetailsDto implements IMappingDetailsDto {
    tenantId: number | undefined;
    id: string | undefined;
    clientProvidedName: string | undefined;
    knipperStandardValueId: string | undefined;
    knipperStandardValueCode: string | undefined;
    knipperStandardValueDesc: string | undefined;

    constructor(data?: IMappingDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.clientProvidedName = _data["clientProvidedName"];
            this.knipperStandardValueId = _data["knipperStandardValueId"];
            this.knipperStandardValueCode = _data["knipperStandardValueCode"];
            this.knipperStandardValueDesc = _data["knipperStandardValueDesc"];
        }
    }

    static fromJS(data: any): MappingDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MappingDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["clientProvidedName"] = this.clientProvidedName;
        data["knipperStandardValueId"] = this.knipperStandardValueId;
        data["knipperStandardValueCode"] = this.knipperStandardValueCode;
        data["knipperStandardValueDesc"] = this.knipperStandardValueDesc;
        return data;
    }

    clone(): MappingDetailsDto {
        const json = this.toJSON();
        let result = new MappingDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IMappingDetailsDto {
    tenantId: number | undefined;
    id: string | undefined;
    clientProvidedName: string | undefined;
    knipperStandardValueId: string | undefined;
    knipperStandardValueCode: string | undefined;
    knipperStandardValueDesc: string | undefined;
}

export class ErrorInfo implements IErrorInfo {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;

    constructor(data?: IErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.details = _data["details"];
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors.push(ValidationErrorInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["details"] = this.details;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }

    clone(): ErrorInfo {
        const json = this.toJSON();
        let result = new ErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IErrorInfo {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;
}

export class ValidationErrorInfo implements IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;

    constructor(data?: IValidationErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members.push(item);
            }
        }
    }

    static fromJS(data: any): ValidationErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        return data;
    }

    clone(): ValidationErrorInfo {
        const json = this.toJSON();
        let result = new ValidationErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;
}

export class AjaxResponseOfMappingDetailsUpdateResultDto implements IAjaxResponseOfMappingDetailsUpdateResultDto {
    result: MappingDetailsUpdateResultDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfMappingDetailsUpdateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? MappingDetailsUpdateResultDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfMappingDetailsUpdateResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfMappingDetailsUpdateResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfMappingDetailsUpdateResultDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfMappingDetailsUpdateResultDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfMappingDetailsUpdateResultDto {
    result: MappingDetailsUpdateResultDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class MappingDetailsUpdateResultDto implements IMappingDetailsUpdateResultDto {
    isUpdatedSuccess: boolean | undefined;
    totalUpdatedCount: number | undefined;
    errorListIfAny: string[] | undefined;

    constructor(data?: IMappingDetailsUpdateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isUpdatedSuccess = _data["isUpdatedSuccess"];
            this.totalUpdatedCount = _data["totalUpdatedCount"];
            if (Array.isArray(_data["errorListIfAny"])) {
                this.errorListIfAny = [] as any;
                for (let item of _data["errorListIfAny"])
                    this.errorListIfAny.push(item);
            }
        }
    }

    static fromJS(data: any): MappingDetailsUpdateResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MappingDetailsUpdateResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUpdatedSuccess"] = this.isUpdatedSuccess;
        data["totalUpdatedCount"] = this.totalUpdatedCount;
        if (Array.isArray(this.errorListIfAny)) {
            data["errorListIfAny"] = [];
            for (let item of this.errorListIfAny)
                data["errorListIfAny"].push(item);
        }
        return data;
    }

    clone(): MappingDetailsUpdateResultDto {
        const json = this.toJSON();
        let result = new MappingDetailsUpdateResultDto();
        result.init(json);
        return result;
    }
}

export interface IMappingDetailsUpdateResultDto {
    isUpdatedSuccess: boolean | undefined;
    totalUpdatedCount: number | undefined;
    errorListIfAny: string[] | undefined;
}

export class AjaxResponseOfExportFileDto implements IAjaxResponseOfExportFileDto {
    result: ExportFileDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfExportFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ExportFileDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfExportFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfExportFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfExportFileDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfExportFileDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfExportFileDto {
    result: ExportFileDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class ExportFileDto implements IExportFileDto {
    fileName: string | undefined;
    fileContent: string | undefined;
    decrypt: boolean | undefined;
    fileLocation: string | undefined;

    constructor(data?: IExportFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileContent = _data["fileContent"];
            this.decrypt = _data["decrypt"];
            this.fileLocation = _data["fileLocation"];
        }
    }

    static fromJS(data: any): ExportFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExportFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileContent"] = this.fileContent;
        data["decrypt"] = this.decrypt;
        data["fileLocation"] = this.fileLocation;
        return data;
    }

    clone(): ExportFileDto {
        const json = this.toJSON();
        let result = new ExportFileDto();
        result.init(json);
        return result;
    }
}

export interface IExportFileDto {
    fileName: string | undefined;
    fileContent: string | undefined;
    decrypt: boolean | undefined;
    fileLocation: string | undefined;
}

export class ClientSpecialtyFileUploadDto implements IClientSpecialtyFileUploadDto {
    tenantId: number | undefined;
    fileUpload: FileUpload | undefined;
    invalidFileMessage: string | undefined;
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    uploadedClientSpecialtyIds: string[] | undefined;
    clientSpecialtiesLoaded: number | undefined;
    clientSpecialtiesInvalid: number | undefined;
    clientSpecialtiesTotal: number | undefined;

    constructor(data?: IClientSpecialtyFileUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.fileUpload = _data["fileUpload"] ? FileUpload.fromJS(_data["fileUpload"]) : <any>undefined;
            this.invalidFileMessage = _data["invalidFileMessage"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["uploadedClientSpecialtyIds"])) {
                this.uploadedClientSpecialtyIds = [] as any;
                for (let item of _data["uploadedClientSpecialtyIds"])
                    this.uploadedClientSpecialtyIds.push(item);
            }
            this.clientSpecialtiesLoaded = _data["clientSpecialtiesLoaded"];
            this.clientSpecialtiesInvalid = _data["clientSpecialtiesInvalid"];
            this.clientSpecialtiesTotal = _data["clientSpecialtiesTotal"];
        }
    }

    static fromJS(data: any): ClientSpecialtyFileUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientSpecialtyFileUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["fileUpload"] = this.fileUpload ? this.fileUpload.toJSON() : <any>undefined;
        data["invalidFileMessage"] = this.invalidFileMessage;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.uploadedClientSpecialtyIds)) {
            data["uploadedClientSpecialtyIds"] = [];
            for (let item of this.uploadedClientSpecialtyIds)
                data["uploadedClientSpecialtyIds"].push(item);
        }
        data["clientSpecialtiesLoaded"] = this.clientSpecialtiesLoaded;
        data["clientSpecialtiesInvalid"] = this.clientSpecialtiesInvalid;
        data["clientSpecialtiesTotal"] = this.clientSpecialtiesTotal;
        return data;
    }

    clone(): ClientSpecialtyFileUploadDto {
        const json = this.toJSON();
        let result = new ClientSpecialtyFileUploadDto();
        result.init(json);
        return result;
    }
}

export interface IClientSpecialtyFileUploadDto {
    tenantId: number | undefined;
    fileUpload: FileUpload | undefined;
    invalidFileMessage: string | undefined;
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    uploadedClientSpecialtyIds: string[] | undefined;
    clientSpecialtiesLoaded: number | undefined;
    clientSpecialtiesInvalid: number | undefined;
    clientSpecialtiesTotal: number | undefined;
}

export class FileUpload implements IFileUpload {
    fileName: string | undefined;
    fileDescription: string | undefined;
    fileType: string | undefined;
    base64FileContent: string | undefined;
    location: string | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    newFlag: boolean | undefined;
    duplicateFileName: boolean | undefined;

    constructor(data?: IFileUpload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileDescription = _data["fileDescription"];
            this.fileType = _data["fileType"];
            this.base64FileContent = _data["base64FileContent"];
            this.location = _data["location"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.newFlag = _data["newFlag"];
            this.duplicateFileName = _data["duplicateFileName"];
        }
    }

    static fromJS(data: any): FileUpload {
        data = typeof data === 'object' ? data : {};
        let result = new FileUpload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileDescription"] = this.fileDescription;
        data["fileType"] = this.fileType;
        data["base64FileContent"] = this.base64FileContent;
        data["location"] = this.location;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["newFlag"] = this.newFlag;
        data["duplicateFileName"] = this.duplicateFileName;
        return data;
    }

    clone(): FileUpload {
        const json = this.toJSON();
        let result = new FileUpload();
        result.init(json);
        return result;
    }
}

export interface IFileUpload {
    fileName: string | undefined;
    fileDescription: string | undefined;
    fileType: string | undefined;
    base64FileContent: string | undefined;
    location: string | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    newFlag: boolean | undefined;
    duplicateFileName: boolean | undefined;
}

export class AjaxResponseOfClientSpecialtyFileUploadDto implements IAjaxResponseOfClientSpecialtyFileUploadDto {
    result: ClientSpecialtyFileUploadDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfClientSpecialtyFileUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ClientSpecialtyFileUploadDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfClientSpecialtyFileUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfClientSpecialtyFileUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfClientSpecialtyFileUploadDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfClientSpecialtyFileUploadDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfClientSpecialtyFileUploadDto {
    result: ClientSpecialtyFileUploadDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class ClientDesignationFileUploadDto implements IClientDesignationFileUploadDto {
    tenantId: number | undefined;
    invalidFileMessage: string | undefined;
    fileUpload: FileUpload | undefined;
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    uploadedClientDesignationIds: string[] | undefined;
    clientDesignationsLoaded: number | undefined;
    clientDesignationsInvalid: number | undefined;
    clientDesignationsTotal: number | undefined;

    constructor(data?: IClientDesignationFileUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.invalidFileMessage = _data["invalidFileMessage"];
            this.fileUpload = _data["fileUpload"] ? FileUpload.fromJS(_data["fileUpload"]) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? new Date(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["uploadedClientDesignationIds"])) {
                this.uploadedClientDesignationIds = [] as any;
                for (let item of _data["uploadedClientDesignationIds"])
                    this.uploadedClientDesignationIds.push(item);
            }
            this.clientDesignationsLoaded = _data["clientDesignationsLoaded"];
            this.clientDesignationsInvalid = _data["clientDesignationsInvalid"];
            this.clientDesignationsTotal = _data["clientDesignationsTotal"];
        }
    }

    static fromJS(data: any): ClientDesignationFileUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDesignationFileUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["invalidFileMessage"] = this.invalidFileMessage;
        data["fileUpload"] = this.fileUpload ? this.fileUpload.toJSON() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.uploadedClientDesignationIds)) {
            data["uploadedClientDesignationIds"] = [];
            for (let item of this.uploadedClientDesignationIds)
                data["uploadedClientDesignationIds"].push(item);
        }
        data["clientDesignationsLoaded"] = this.clientDesignationsLoaded;
        data["clientDesignationsInvalid"] = this.clientDesignationsInvalid;
        data["clientDesignationsTotal"] = this.clientDesignationsTotal;
        return data;
    }

    clone(): ClientDesignationFileUploadDto {
        const json = this.toJSON();
        let result = new ClientDesignationFileUploadDto();
        result.init(json);
        return result;
    }
}

export interface IClientDesignationFileUploadDto {
    tenantId: number | undefined;
    invalidFileMessage: string | undefined;
    fileUpload: FileUpload | undefined;
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    uploadedClientDesignationIds: string[] | undefined;
    clientDesignationsLoaded: number | undefined;
    clientDesignationsInvalid: number | undefined;
    clientDesignationsTotal: number | undefined;
}

export class AjaxResponseOfClientDesignationFileUploadDto implements IAjaxResponseOfClientDesignationFileUploadDto {
    result: ClientDesignationFileUploadDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfClientDesignationFileUploadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ClientDesignationFileUploadDto.fromJS(_data["result"]) : <any>undefined;
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfClientDesignationFileUploadDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfClientDesignationFileUploadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfClientDesignationFileUploadDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfClientDesignationFileUploadDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfClientDesignationFileUploadDto {
    result: ClientDesignationFileUploadDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class AjaxResponseOfIEnumerableOfTenantFileDto implements IAjaxResponseOfIEnumerableOfTenantFileDto {
    result: TenantFileDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfIEnumerableOfTenantFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result.push(TenantFileDto.fromJS(item));
            }
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorInfo.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            (<any>this).__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfIEnumerableOfTenantFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfIEnumerableOfTenantFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item.toJSON());
        }
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }

    clone(): AjaxResponseOfIEnumerableOfTenantFileDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfIEnumerableOfTenantFileDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfIEnumerableOfTenantFileDto {
    result: TenantFileDto[] | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class TenantFileDto implements ITenantFileDto {
    fileTypeId: string | undefined;
    hasErrors: boolean | undefined;
    hasMissingFile: boolean | undefined;
    fileName: string | undefined;
    fileLocation: string | undefined;
    lastUpdatedDateTime: Date | undefined;

    constructor(data?: ITenantFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileTypeId = _data["fileTypeId"];
            this.hasErrors = _data["hasErrors"];
            this.hasMissingFile = _data["hasMissingFile"];
            this.fileName = _data["fileName"];
            this.fileLocation = _data["fileLocation"];
            this.lastUpdatedDateTime = _data["lastUpdatedDateTime"] ? new Date(_data["lastUpdatedDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileTypeId"] = this.fileTypeId;
        data["hasErrors"] = this.hasErrors;
        data["hasMissingFile"] = this.hasMissingFile;
        data["fileName"] = this.fileName;
        data["fileLocation"] = this.fileLocation;
        data["lastUpdatedDateTime"] = this.lastUpdatedDateTime ? this.lastUpdatedDateTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): TenantFileDto {
        const json = this.toJSON();
        let result = new TenantFileDto();
        result.init(json);
        return result;
    }
}

export interface ITenantFileDto {
    fileTypeId: string | undefined;
    hasErrors: boolean | undefined;
    hasMissingFile: boolean | undefined;
    fileName: string | undefined;
    fileLocation: string | undefined;
    lastUpdatedDateTime: Date | undefined;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}